<template>
  <div class="card">
    <el-input type="search" clearable class="input-sm" placeholder="Filter Deployments" v-model="search.query[data.id]" aria-controls="datatables" style="width:350px; margin: 10px;" />
    <el-table :data="deployments"
              class="wrap-whole-words indexed-table-column-width"
              :highlight-current-row="false"
              border
              :max-height="tableHeight(450)"
              style="width: 100%">
      <el-table-column
        :width="this.constants.INDEX_COLUMN_WIDTHS.WIDE"
        align="center"
        label="#"
        type="index" />
      <el-table-column v-for="column in tableColumns"
                       :key="column.label"
                       :min-width="column.minWidth"
                       :prop="column.prop"
                       :label="column.label">
      </el-table-column>
      <el-table-column
        label="Version"
        :min-width="100">
        <template slot-scope="props">
          {{ props.row.processDefinitions[0].version}}
        </template>
      </el-table-column>
      <el-table-column
        label="Deployment Date"
        :min-width="100"
        sortable
        :sort-method="(a, b) => actualDateSort(a, b)">
        <template slot-scope="props">
          {{ props.row.createdAt | formatDate}}
        </template>
      </el-table-column>
      <el-table-column
        v-if="canEdit"
        width="125"
        label="Actions">
        <template slot-scope="props">
          <div style="text-align: center;">
            <p-button type="info" size="med" icon @click="showProcessDefinitionInfoModal(props.row)">
              <i class="fa fa-info"></i>
            </p-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Permissions from 'src/utilities/permissions'
import Constants from 'src/utilities/constants'
import {getTableHeight} from 'src/utilities/utils'
import {sync} from "vuex-pathify";

export default {
  props: ['data'],
  computed: {
    search: sync('camunda@search'),
    canEdit() {
      return this.$can('edit', Permissions.CAMUNDA)
    },
    deployments() {
      const deployments = this.$store.get('camunda/deploymentsByDepartmentById', this.data.id)

      if (this.search.query[this.data.id] && this.search.query[this.data.id].length > 0) {
        return deployments.filter((deployment) => deployment.name.toLowerCase().includes(this.search.query[this.data.id].toLowerCase()))
      }

      return deployments
    }
  },
  data() {
    return {
      tableColumns: [
        {
          prop: 'name',
          label: 'Name',
          minWidth: 120
        },
        {
          prop: 'id',
          label: 'ID',
          minWidth: 150
        }
      ],
      constants: Constants
    }
  },
  methods: {
    showProcessDefinitionInfoModal(deployment) {
      this.$eventHub.$emit('show-modal-1', 'Process Definition', deployment, '90%')
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    actualDateSort(a, b) {
      if (!a.hasOwnProperty('createdAt') || a['createdAt'] === undefined) {
        return 1
      }
      if (!b.hasOwnProperty('createdAt') || b['createdAt'] === undefined) {
        return -1
      }
      return new Date(b.createdAt) - new Date(a.createdAt)
    }
  }
}
</script>
